/* eslint-disable */

/** All built-in and custom scalars, mapped to their actual values */

export var App_Action = /*#__PURE__*/function (App_Action) {
  App_Action["Approve"] = "APPROVE";
  App_Action["APPROVE"] = "APPROVE";
  App_Action["Decline"] = "DECLINE";
  App_Action["DECLINE"] = "DECLINE";
  return App_Action;
}({});
export var App_Allow_Notifications = /*#__PURE__*/function (App_Allow_Notifications) {
  App_Allow_Notifications["Allow"] = "ALLOW";
  App_Allow_Notifications["ALLOW"] = "ALLOW";
  App_Allow_Notifications["Reject"] = "REJECT";
  App_Allow_Notifications["REJECT"] = "REJECT";
  return App_Allow_Notifications;
}({});
/**
 * This is a list of error codes generated by this service.
 *
 * In addition to these error codes, errors that are generated by Auth0 / APW will also have a
 * "apw_error" field with the original payload of that error.
 *
 * This list is meant to identify errors for easier client integration, but it should be
 * treated as non-comprehensive.
 */
export var ErrorCodes = /*#__PURE__*/function (ErrorCodes) {
  ErrorCodes["BrazeError"] = "braze_error";
  ErrorCodes["braze_error"] = "braze_error";
  ErrorCodes["DeviceManagementError"] = "device_management_error";
  ErrorCodes["device_management_error"] = "device_management_error";
  ErrorCodes["DownstreamServerIssue"] = "downstream_server_issue";
  ErrorCodes["downstream_server_issue"] = "downstream_server_issue";
  ErrorCodes["ExpiredResetToken"] = "expired_reset_token";
  ErrorCodes["expired_reset_token"] = "expired_reset_token";
  ErrorCodes["InactiveLmsCampaign"] = "inactive_lms_campaign";
  ErrorCodes["inactive_lms_campaign"] = "inactive_lms_campaign";
  ErrorCodes["InactiveUser"] = "inactive_user";
  ErrorCodes["inactive_user"] = "inactive_user";
  ErrorCodes["InternalError"] = "internal_error";
  ErrorCodes["internal_error"] = "internal_error";
  ErrorCodes["InternalUserTokenExpired"] = "internal_user_token_expired";
  ErrorCodes["internal_user_token_expired"] = "internal_user_token_expired";
  ErrorCodes["InvalidDevice"] = "invalid_device";
  ErrorCodes["invalid_device"] = "invalid_device";
  ErrorCodes["InvalidEmail"] = "invalid_email";
  ErrorCodes["invalid_email"] = "invalid_email";
  ErrorCodes["InvalidEmailStructure"] = "invalid_email_structure";
  ErrorCodes["invalid_email_structure"] = "invalid_email_structure";
  ErrorCodes["InvalidLmsToken"] = "invalid_lms_token";
  ErrorCodes["invalid_lms_token"] = "invalid_lms_token";
  ErrorCodes["InvalidMfaStatus"] = "invalid_mfa_status";
  ErrorCodes["invalid_mfa_status"] = "invalid_mfa_status";
  ErrorCodes["InvalidMfaToken"] = "invalid_mfa_token";
  ErrorCodes["invalid_mfa_token"] = "invalid_mfa_token";
  ErrorCodes["InvalidOtpId"] = "invalid_otp_id";
  ErrorCodes["invalid_otp_id"] = "invalid_otp_id";
  ErrorCodes["InvalidOtpToken"] = "invalid_otp_token";
  ErrorCodes["invalid_otp_token"] = "invalid_otp_token";
  ErrorCodes["InvalidParams"] = "invalid_params";
  ErrorCodes["invalid_params"] = "invalid_params";
  ErrorCodes["InvalidRecaptcha"] = "invalid_recaptcha";
  ErrorCodes["invalid_recaptcha"] = "invalid_recaptcha";
  ErrorCodes["InvalidRequest"] = "invalid_request";
  ErrorCodes["invalid_request"] = "invalid_request";
  ErrorCodes["InvalidResetToken"] = "invalid_reset_token";
  ErrorCodes["invalid_reset_token"] = "invalid_reset_token";
  ErrorCodes["InvalidUser"] = "invalid_user";
  ErrorCodes["invalid_user"] = "invalid_user";
  ErrorCodes["LmsActiveCampaign"] = "lms_active_campaign";
  ErrorCodes["lms_active_campaign"] = "lms_active_campaign";
  ErrorCodes["LmsUserForbiddenResetPassword"] = "lms_user_forbidden_reset_password";
  ErrorCodes["lms_user_forbidden_reset_password"] = "lms_user_forbidden_reset_password";
  ErrorCodes["MergedClientCredentialsUsed"] = "merged_client_credentials_used";
  ErrorCodes["merged_client_credentials_used"] = "merged_client_credentials_used";
  ErrorCodes["MfaRequired"] = "mfa_required";
  ErrorCodes["mfa_required"] = "mfa_required";
  ErrorCodes["MigrationClient"] = "migration_client";
  ErrorCodes["migration_client"] = "migration_client";
  ErrorCodes["MissingIdToken"] = "missing_id_token";
  ErrorCodes["missing_id_token"] = "missing_id_token";
  ErrorCodes["OldPassword"] = "old_password";
  ErrorCodes["old_password"] = "old_password";
  ErrorCodes["OtpApiError"] = "otp_api_error";
  ErrorCodes["otp_api_error"] = "otp_api_error";
  ErrorCodes["OtpTokenVerificationFailed"] = "otp_token_verification_failed";
  ErrorCodes["otp_token_verification_failed"] = "otp_token_verification_failed";
  ErrorCodes["SlowDown"] = "slow_down";
  ErrorCodes["slow_down"] = "slow_down";
  ErrorCodes["UserAlreadyExists"] = "user_already_exists";
  ErrorCodes["user_already_exists"] = "user_already_exists";
  ErrorCodes["UserAlreadyExistsMigrated"] = "user_already_exists_migrated";
  ErrorCodes["user_already_exists_migrated"] = "user_already_exists_migrated";
  ErrorCodes["UserNotFound"] = "user_not_found";
  ErrorCodes["user_not_found"] = "user_not_found";
  ErrorCodes["WrongPassword"] = "wrong_password";
  ErrorCodes["wrong_password"] = "wrong_password";
  return ErrorCodes;
}({});
export var Institution = /*#__PURE__*/function (Institution) {
  Institution["Nmsu"] = "NMSU";
  Institution["NMSU"] = "NMSU";
  return Institution;
}({});
export var Mfa_Status = /*#__PURE__*/function (Mfa_Status) {
  Mfa_Status["AppDeclinedPush"] = "APP_DECLINED_PUSH";
  Mfa_Status["APP_DECLINED_PUSH"] = "APP_DECLINED_PUSH";
  Mfa_Status["Blocked"] = "BLOCKED";
  Mfa_Status["BLOCKED"] = "BLOCKED";
  Mfa_Status["Expired"] = "EXPIRED";
  Mfa_Status["EXPIRED"] = "EXPIRED";
  Mfa_Status["MfaRequired"] = "MFA_REQUIRED";
  Mfa_Status["MFA_REQUIRED"] = "MFA_REQUIRED";
  Mfa_Status["Onboarding"] = "ONBOARDING";
  Mfa_Status["ONBOARDING"] = "ONBOARDING";
  Mfa_Status["OsDeclinedPush"] = "OS_DECLINED_PUSH";
  Mfa_Status["OS_DECLINED_PUSH"] = "OS_DECLINED_PUSH";
  Mfa_Status["Sent"] = "SENT";
  Mfa_Status["SENT"] = "SENT";
  Mfa_Status["Verified"] = "VERIFIED";
  Mfa_Status["VERIFIED"] = "VERIFIED";
  return Mfa_Status;
}({});

/** This is the payload of apw_error field when the error is mfa_required */

export var OptInMfaStatus = /*#__PURE__*/function (OptInMfaStatus) {
  OptInMfaStatus["Fail"] = "Fail";
  OptInMfaStatus["Success"] = "Success";
  return OptInMfaStatus;
}({});
export var ResetPasswordStatus = /*#__PURE__*/function (ResetPasswordStatus) {
  ResetPasswordStatus["Fail"] = "Fail";
  ResetPasswordStatus["Success"] = "Success";
  return ResetPasswordStatus;
}({});
export var SsoProviders = /*#__PURE__*/function (SsoProviders) {
  SsoProviders["Apple"] = "apple";
  SsoProviders["apple"] = "apple";
  SsoProviders["Facebook"] = "facebook";
  SsoProviders["facebook"] = "facebook";
  SsoProviders["Google"] = "google";
  SsoProviders["google"] = "google";
  SsoProviders["Microsoft"] = "microsoft";
  SsoProviders["microsoft"] = "microsoft";
  SsoProviders["OpenPass"] = "openPass";
  SsoProviders["openPass"] = "openPass";
  return SsoProviders;
}({});
export var Status = /*#__PURE__*/function (Status) {
  Status["Fail"] = "FAIL";
  Status["FAIL"] = "FAIL";
  Status["Success"] = "SUCCESS";
  Status["SUCCESS"] = "SUCCESS";
  return Status;
}({});
export var StudentType = /*#__PURE__*/function (StudentType) {
  StudentType["College"] = "college";
  StudentType["college"] = "college";
  StudentType["Highschool"] = "highschool";
  StudentType["highschool"] = "highschool";
  return StudentType;
}({});
export var TokenType = /*#__PURE__*/function (TokenType) {
  TokenType["AccessToken"] = "accessToken";
  TokenType["accessToken"] = "accessToken";
  TokenType["AuthenticationToken"] = "authenticationToken";
  TokenType["authenticationToken"] = "authenticationToken";
  TokenType["AuthorizationCode"] = "authorizationCode";
  TokenType["authorizationCode"] = "authorizationCode";
  TokenType["IdToken"] = "idToken";
  TokenType["idToken"] = "idToken";
  return TokenType;
}({});
export var UserType = /*#__PURE__*/function (UserType) {
  UserType["Parent"] = "parent";
  UserType["parent"] = "parent";
  UserType["Student"] = "student";
  UserType["student"] = "student";
  UserType["Teacher"] = "teacher";
  UserType["teacher"] = "teacher";
  return UserType;
}({});
export var AuthenticateMfaDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'mutation',
    name: {
      kind: 'Name',
      value: 'AuthenticateMfa'
    },
    variableDefinitions: [{
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'params'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'MFAByAppParams'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'clientId'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'deviceId'
        }
      },
      type: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'String'
        }
      }
    }],
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'authenticateMFA'
        },
        arguments: [{
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'mfaByAppParams'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'params'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'clientId'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'clientId'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'deviceId'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'deviceId'
            }
          }
        }],
        selectionSet: {
          kind: 'SelectionSet',
          selections: [{
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'tokens'
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'idToken'
                }
              }, {
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'accessToken'
                }
              }, {
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'expires'
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};
export var LoginDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'query',
    name: {
      kind: 'Name',
      value: 'Login'
    },
    variableDefinitions: [{
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'email'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'password'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'client'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'forceMfa'
        }
      },
      type: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'Boolean'
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'deviceId'
        }
      },
      type: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'String'
        }
      }
    }],
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'userTokens'
        },
        arguments: [{
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'params'
          },
          value: {
            kind: 'ObjectValue',
            fields: [{
              kind: 'ObjectField',
              name: {
                kind: 'Name',
                value: 'email'
              },
              value: {
                kind: 'Variable',
                name: {
                  kind: 'Name',
                  value: 'email'
                }
              }
            }, {
              kind: 'ObjectField',
              name: {
                kind: 'Name',
                value: 'password'
              },
              value: {
                kind: 'Variable',
                name: {
                  kind: 'Name',
                  value: 'password'
                }
              }
            }, {
              kind: 'ObjectField',
              name: {
                kind: 'Name',
                value: 'clientId'
              },
              value: {
                kind: 'Variable',
                name: {
                  kind: 'Name',
                  value: 'client'
                }
              }
            }, {
              kind: 'ObjectField',
              name: {
                kind: 'Name',
                value: 'forceMfa'
              },
              value: {
                kind: 'Variable',
                name: {
                  kind: 'Name',
                  value: 'forceMfa'
                }
              }
            }, {
              kind: 'ObjectField',
              name: {
                kind: 'Name',
                value: 'deviceId'
              },
              value: {
                kind: 'Variable',
                name: {
                  kind: 'Name',
                  value: 'deviceId'
                }
              }
            }]
          }
        }],
        selectionSet: {
          kind: 'SelectionSet',
          selections: [{
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'tokens'
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'idToken'
                }
              }, {
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'accessToken'
                }
              }, {
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'expires'
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};
export var GetErrorCodesDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'query',
    name: {
      kind: 'Name',
      value: 'GetErrorCodes'
    },
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'getErrorCodes'
        }
      }, {
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'getMfaErrorPayload'
        },
        selectionSet: {
          kind: 'SelectionSet',
          selections: [{
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'mfa_token'
            }
          }, {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'uuid'
            }
          }, {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'email'
            }
          }]
        }
      }]
    }
  }]
};
export var LogoutDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'query',
    name: {
      kind: 'Name',
      value: 'Logout'
    },
    variableDefinitions: [{
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'client'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }],
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'logout'
        },
        arguments: [{
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'clientId'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'client'
            }
          }
        }]
      }]
    }
  }]
};
export var GetEmailCodeDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'query',
    name: {
      kind: 'Name',
      value: 'GetEmailCode'
    },
    variableDefinitions: [{
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'token'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'client'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }],
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'mfaEmailCode'
        },
        arguments: [{
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'mfaToken'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'token'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'clientId'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'client'
            }
          }
        }]
      }]
    }
  }]
};
export var PerformMfaDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'query',
    name: {
      kind: 'Name',
      value: 'PerformMfa'
    },
    variableDefinitions: [{
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'mfaToken'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'oobCode'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'mfaCode'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'deviceId'
        }
      },
      type: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'String'
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'client'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }],
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'mfaTokens'
        },
        arguments: [{
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'mfaToken'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'mfaToken'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'oobCode'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'oobCode'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'mfaCode'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'mfaCode'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'deviceId'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'deviceId'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'clientId'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'client'
            }
          }
        }],
        selectionSet: {
          kind: 'SelectionSet',
          selections: [{
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'tokens'
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'idToken'
                }
              }, {
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'accessToken'
                }
              }, {
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'expires'
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};
export var GetMfaTokenDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'query',
    name: {
      kind: 'Name',
      value: 'GetMfaToken'
    },
    variableDefinitions: [{
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'client'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }],
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'mfaToken'
        },
        arguments: [{
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'clientId'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'client'
            }
          }
        }]
      }]
    }
  }]
};
export var MfaStatusDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'query',
    name: {
      kind: 'Name',
      value: 'MfaStatus'
    },
    variableDefinitions: [{
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'mfaToken'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'userUuid'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'clientId'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'NonEmptyString'
          }
        }
      }
    }],
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'mfaStatus'
        },
        arguments: [{
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'mfaToken'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'mfaToken'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'userUuid'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'userUuid'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'clientId'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'clientId'
            }
          }
        }],
        selectionSet: {
          kind: 'SelectionSet',
          selections: [{
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'otpToken'
            }
          }, {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'status'
            }
          }]
        }
      }]
    }
  }]
};
export var RefreshTokenDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'query',
    name: {
      kind: 'Name',
      value: 'RefreshToken'
    },
    variableDefinitions: [{
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'client'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }],
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'refreshToken'
        },
        arguments: [{
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'clientId'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'client'
            }
          }
        }],
        selectionSet: {
          kind: 'SelectionSet',
          selections: [{
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'tokens'
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'accessToken'
                }
              }, {
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'idToken'
                }
              }, {
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'expires'
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};
export var ResetPasswordDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'mutation',
    name: {
      kind: 'Name',
      value: 'ResetPassword'
    },
    variableDefinitions: [{
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'clientId'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'newPassword'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'token'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }],
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'resetPassword'
        },
        arguments: [{
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'clientId'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'clientId'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'newPassword'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'newPassword'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'token'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'token'
            }
          }
        }],
        selectionSet: {
          kind: 'SelectionSet',
          selections: [{
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'status'
            }
          }, {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'token'
            }
          }]
        }
      }]
    }
  }]
};
export var SendAppMfaCodeDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'mutation',
    name: {
      kind: 'Name',
      value: 'SendAppMfaCode'
    },
    variableDefinitions: [{
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'mfaToken'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'userUuid'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'clientId'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'NonEmptyString'
          }
        }
      }
    }],
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'sendAppMfaCode'
        },
        arguments: [{
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'mfaToken'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'mfaToken'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'userUuid'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'userUuid'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'clientId'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'clientId'
            }
          }
        }],
        selectionSet: {
          kind: 'SelectionSet',
          selections: [{
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'status'
            }
          }, {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'qrLink'
            }
          }]
        }
      }]
    }
  }]
};
export var SendResetPasswordEmailDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'query',
    name: {
      kind: 'Name',
      value: 'SendResetPasswordEmail'
    },
    variableDefinitions: [{
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'clientId'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'email'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'redirect'
        }
      },
      type: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'String'
        }
      }
    }],
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'sendResetPasswordEmail'
        },
        arguments: [{
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'clientId'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'clientId'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'email'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'email'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'redirect'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'redirect'
            }
          }
        }],
        selectionSet: {
          kind: 'SelectionSet',
          selections: [{
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'status'
            }
          }, {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'token'
            }
          }]
        }
      }]
    }
  }]
};
export var SignupDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'mutation',
    name: {
      kind: 'Name',
      value: 'Signup'
    },
    variableDefinitions: [{
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'userCredentials'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'UserCredentials'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'userProfile'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'UserProfile'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'clientId'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }],
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'signUpUser'
        },
        arguments: [{
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'userCredentials'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'userCredentials'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'userProfile'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'userProfile'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'clientId'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'clientId'
            }
          }
        }],
        selectionSet: {
          kind: 'SelectionSet',
          selections: [{
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'tokens'
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'idToken'
                }
              }, {
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'accessToken'
                }
              }, {
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'expires'
                }
              }]
            }
          }, {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'encryptedEmail'
            }
          }, {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'encryptedCheggId'
            }
          }, {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'uuid'
            }
          }]
        }
      }]
    }
  }]
};
export var SsoLoginDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'query',
    name: {
      kind: 'Name',
      value: 'SsoLogin'
    },
    variableDefinitions: [{
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'client'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'provider'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'SsoProviders'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'email'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'token'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }],
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'ssoTokens'
        },
        arguments: [{
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'clientId'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'client'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'provider'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'provider'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'email'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'email'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'providerToken'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'token'
            }
          }
        }],
        selectionSet: {
          kind: 'SelectionSet',
          selections: [{
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'tokens'
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'idToken'
                }
              }, {
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'accessToken'
                }
              }, {
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'expires'
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};
export var SsoSignupDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'mutation',
    name: {
      kind: 'Name',
      value: 'SsoSignup'
    },
    variableDefinitions: [{
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'ssoUserCredentials'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'SsoUserCredentials'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'userDetails'
        }
      },
      type: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'SsoUserDetails'
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'userProfile'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'UserProfile'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'clientId'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }],
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'signUpSsoUser'
        },
        arguments: [{
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'ssoUserCredentials'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'ssoUserCredentials'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'userDetails'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'userDetails'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'userProfile'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'userProfile'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'clientId'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'clientId'
            }
          }
        }],
        selectionSet: {
          kind: 'SelectionSet',
          selections: [{
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'tokens'
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'idToken'
                }
              }, {
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'accessToken'
                }
              }, {
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'expires'
                }
              }]
            }
          }, {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'encryptedCheggId'
            }
          }, {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'encryptedEmail'
            }
          }, {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'uuid'
            }
          }]
        }
      }]
    }
  }]
};
export var SsoAuthTokensDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'mutation',
    name: {
      kind: 'Name',
      value: 'SsoAuthTokens'
    },
    variableDefinitions: [{
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'ssoUserCredentials'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'SsoUserCredentials'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'clientId'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }],
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'ssoAuthTokens'
        },
        arguments: [{
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'ssoUserCredentials'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'ssoUserCredentials'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'clientId'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'clientId'
            }
          }
        }],
        selectionSet: {
          kind: 'SelectionSet',
          selections: [{
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'userCreated'
            }
          }, {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'tokens'
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'idToken'
                }
              }, {
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'accessToken'
                }
              }, {
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: 'expires'
                }
              }]
            }
          }, {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'encryptedCheggId'
            }
          }, {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'encryptedEmail'
            }
          }, {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'uuid'
            }
          }]
        }
      }]
    }
  }]
};
export var ValidateEmailAddressDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'query',
    name: {
      kind: 'Name',
      value: 'ValidateEmailAddress'
    },
    variableDefinitions: [{
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'email'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }, {
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'clientId'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }],
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'validateEmailAddress'
        },
        arguments: [{
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'email'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'email'
            }
          }
        }, {
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'clientId'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'clientId'
            }
          }
        }],
        selectionSet: {
          kind: 'SelectionSet',
          selections: [{
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'status'
            }
          }]
        }
      }]
    }
  }]
};